module.exports = __webpack_public_path__ + "img/image-icon-tadah.7a4e8f40.gif";